import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FormSearch } from '../../models/dashboard/FormStatus';
import { RequestFormView } from '../../models/form/RequestFormView';
import { BaseDashboard } from '../../models/dashboard/BaseDashboard';
import { UtilityService } from '../utility.service';
import { RequestCreator } from '../../models/form/RequestCreator';
import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class RequestFormService {
	constructor(private httpClient: HttpClient, private utilityService: UtilityService) {}

	createForm(clientId: string, form: RequestCreator): Observable<RequestFormView> {
		const formData: FormData = new FormData();
		for (let i = 0; i < form.attachments.length; i++) {
			const name = `attachment-${i + 1}`;
			formData.append(name, form.attachments[i].file);
			form.attachments[i].file = null;
			form.attachments[i].name = name;
		}

		formData.append('model', JSON.stringify(form));
		return this.httpClient
			.post<RequestFormView>(`${environment.apiUrl}forms/clients/${clientId}/request-form`, formData)
			.pipe();
	}

	updateForm(clientId: string, formId: string, request: any): Observable<any> {
		return this.httpClient
			.put<any>(`${environment.apiUrl}forms/clients/${clientId}/request-form/${formId}`, request)
			.pipe();
	}

	getFormsFor(clientId: string, userId: string, search: FormSearch): Observable<BaseDashboard<any>> {
		let url = `${
			environment.apiUrl
		}forms/clients/${clientId}/request-form/users/${userId}?${this.utilityService.objectToQueryString(search)}`;
		return this.httpClient.get<BaseDashboard<any>>(url).pipe();
	}

	getForm(id: string, clientId: string): Observable<RequestFormView> {
		return this.httpClient
			.get<RequestFormView>(`${environment.apiUrl}forms/clients/${clientId}/request-form/${id}`)
			.pipe();
	}

	rejectForm(
		clientId: string,
		formId: string,
		rejectionReason: { reason: string; workflowId: number }
	): Observable<RequestFormView> {
		return this.httpClient
			.post<RequestFormView>(
				`${environment.apiUrl}forms/clients/${clientId}/request-form/${formId}/decline`,
				rejectionReason
			)
			.pipe();
	}

	approveForm(clientId: string, formId: string, userId: string): Observable<RequestFormView> {
		return this.httpClient
			.post<RequestFormView>(`${environment.apiUrl}forms/clients/${clientId}/request-form/${formId}/approve`, {
				userId,
			})
			.pipe();
	}

	submitDeliverables(clientId: string, formId: string, request: any): Observable<RequestFormView> {
		const formData: FormData = new FormData();
		for (let i = 0; i < request.deliverables.length; i++) {
			const name = `deliverable-${i + 1}`;
			formData.append(name, request.deliverables[i].file);
			request.deliverables[i].file = null;
			request.deliverables[i].name = name;
		}

		formData.append('model', JSON.stringify(request));

		return this.httpClient
			.post<RequestFormView>(
				`${environment.apiUrl}forms/clients/${clientId}/request-form/${formId}/deliverables`,
				formData
			)
			.pipe();
	}

	sendBack(clientId: string, formId: string): Observable<RequestFormView> {
		return this.httpClient
			.post<RequestFormView>(`${environment.apiUrl}forms/clients/${clientId}/request-form/${formId}/review`, {})
			.pipe();
	}

	delegatedTo(clientId: string, formId: string, userId: any): Observable<RequestFormView> {
		return this.httpClient
			.post<RequestFormView>(`${environment.apiUrl}forms/clients/${clientId}/request-form/${formId}/delegate`, {
				userId,
			})
			.pipe();
	}

	cancelSchedule(id: string, clientId: string): Observable<RequestFormView> {
		return this.httpClient
			.delete<RequestFormView>(`${environment.apiUrl}forms/clients/${clientId}/request-form/${id}/cancelSchedule`)
			.pipe();
	}

	getRequestFormsForScheduling(clientId: string, data: any): Observable<RequestFormView[]> {
		return this.httpClient
			.post<RequestFormView[]>(`${environment.apiUrl}forms/clients/${clientId}/request-form/manage/scheduling`, data)
			.pipe();
	}

	updateRequestFormForScheduling(clientId: string, message: any): Observable<RequestFormView[]> {
		return this.httpClient
			.post<RequestFormView[]>(
				`${environment.apiUrl}forms/clients/${clientId}/request-form/manage/scheduling/update`,
				message
			)
			.pipe();
	}

	submitForApproval(clientId: string, id: any, userId: string): Observable<any> {
		return this.httpClient
			.post<any>(`${environment.apiUrl}forms/clients/${clientId}/request-form/${id}/approval`, {
				userId,
			})
			.pipe();
	}
}
